/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * GroupArray.web.js - Shows counters in a formation
 */

import GroupElement from './GroupElement';
import * as colours from '../../colours';
import './Group.web.css';
import { Formation } from './types';


interface GroupArrayProps {
  formation: Formation
}

const GroupArray = ({ formation }: GroupArrayProps) => {
  let row = [];
  const cols = [];

  const numRows = 5;
  const numCols = 5;

  for (let i = 0; i < numRows; i++) {
    for (let j = 0; j < numCols; j++) {
      const elementNum = (i + 1) * (j + 1);
      if (formation[i][j] === 1) {
        row.push(
          <GroupElement key={`element${elementNum}`} color={colours.red}/>
        );
      } else {
        row.push(
          <GroupElement key={`element${elementNum}`} color="clear" />
        );
      }
    }
    cols.push(
      <div key={`groupSquare${i}`} className='groupArrayCol'>
        {row}
      </div>
    );
    row = [];
  }

  return (
    <div className="groupFrame">
      {cols}
    </div>
  );
};

export default GroupArray;
